/**
 * Activity Drawer Constants
 * Constants for displaying activity logs and field changes
 */

export const PAGE_SIZE = 5;

/**
 * Change type configuration for activity log display
 */
export const CHANGE_TYPE_CONFIG = {
  added: {
    iconName: 'HiPlus' as const,
    iconColorClass: 'text-green-500',
    bgColorClass: 'bg-green-50 dark:bg-green-900/30',
    borderClass: 'border-green-200 dark:border-green-700',
    label: 'Added',
  },
  deleted: {
    iconName: 'HiMinus' as const,
    iconColorClass: 'text-red-500',
    bgColorClass: 'bg-red-50 dark:bg-red-900/30',
    borderClass: 'border-red-200 dark:border-red-700',
    label: 'Deleted',
  },
  updated: {
    iconName: 'FaWater' as const,
    iconColorClass: 'text-blue-500',
    bgColorClass: 'bg-blue-50 dark:bg-blue-900/30',
    borderClass: 'border-blue-200 dark:border-blue-700',
    label: 'Updated',
  },
} as const;

export const DEFAULT_CHANGE_CONFIG = {
  iconName: 'HiInformationCircle' as const,
  iconColorClass: 'text-gray-500',
  bgColorClass: 'bg-gray-50 dark:bg-gray-900/30',
  borderClass: 'border-gray-200 dark:border-gray-700',
  label: 'Changed',
};
